const messages = {
    buttons: {
        productBrochures: "Entdecken",
    },
    index: {
        title: "PRODUKTINFORMATIONEN",
        description: "Laden Sie hier die neuesten Broschüren und Flyer unserer Bridgestone- und Firestone-Reifen herunter.",
        categories: {
            productBrochures: {
                title: "Produktbroschüren",
                description: "Broschüren der Bridgestone- und Firestone-Reifenserien",
            },
            bDrive: {
              title: "Produkt-Abbildungen",
              description: "Aktuelle Abbildungen finden Sie in unserem B-DRIVE Portal zum Download",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

